import React from 'react';
import 'animate.css/animate.min.css';
import './App.css';
import './pages/create-account/style.css';
import './pages/login-help/style.css';
import Router from './routes';
import { ParallaxProvider } from 'react-scroll-parallax';
import { TrackingProvider } from './context/trackingContext';
import { UserProvider } from './context/userContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from './config';

function App() {
  return (
    <TrackingProvider>
      <ParallaxProvider>
        <UserProvider>
          <GoogleReCaptchaProvider reCaptchaKey={config.recaptchaPublicKey}>
            <Router />
          </GoogleReCaptchaProvider>
        </UserProvider>
      </ParallaxProvider>
    </TrackingProvider>
  );
}

export default App;
